<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="shortlist-connect-page">
      <div class="container">
        <favorite-connect-header type="project" />
        <page-loading :show="loading" />
        <div class="shortlist-connect-panel">
          <project-connect-content
            :projects="shortlists"
            :meta="meta"
            :loading="loading"
            :locked="locked"
            :error="error"
            :is-shortlist="true"
            :action-loading-id="actionLoadingId"
            empty-text="Belum ada shortlist Project Connect."
            @open-whatsapp="openWhatsapp"
            @remove="confirmRemove"
            @change-page="changePage"
          />
        </div>
      </div>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import FavoriteConnectHeader from '@/components/search-listing/favorite-connect-header.vue';
import ProjectConnectContent from '@/components/project-connect/project-connect-content.vue';
import PageLoading from '@/components/content-loading/page-loading.vue';
import { mapState } from 'vuex';

export default {
  name: 'shortlist-project-connect',
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    FavoriteConnectHeader,
    ProjectConnectContent,
    PageLoading,
  },
  computed: {
    ...mapState({
      shortlists: (state) => state.projectConnect.shortlists,
      meta: (state) => state.projectConnect.shortlistsMeta,
      loading: (state) => state.projectConnect.loading,
      locked: (state) => state.projectConnect.locked,
      error: (state) => state.projectConnect.error,
      actionLoadingId: (state) => state.projectConnect.actionLoadingId,
      user: (state) => state.global.user,
    }),
    breadcrumbs() {
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: 'Project Connect',
          to: '/layanan-agen/project-connect',
        },
        {
          text: 'Shortlist Project Connect',
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  methods: {
    async getShortlists(page) {
      await this.$store.dispatch('projectConnect/getShortlists', page || this.$route.query.page);
    },
    async changePage(page) {
      await this.getShortlists(page);
    },
    getProjectName(project) {
      return project.project_name || project.title || 'project';
    },
    formatWhatsappUrl(project) {
      const phone = project && project.phone_number ? project.phone_number : '';
      const formattedPhone = String(phone || '').replace(/\D/g, '');
      if (!formattedPhone) return null;
      const whatsappNumber = formattedPhone.startsWith('62')
        ? formattedPhone
        : '62' + formattedPhone.replace(/^0+/, '');
      const picName = project.pic_name || 'Bapak/Ibu';
      const agentName = this.user && this.user.name ? this.user.name : 'Agen BeliRumah';
      const projectName = this.getProjectName(project);
      const text = `Halo ${picName}, perkenalkan saya ${agentName}, agen terdaftar dari BeliRumah.co. Saya mendapatkan kontak Bapak/Ibu melalui fitur Project Connect BeliRumah.co dan tertarik untuk membantu memasarkan ${projectName}. Mohon informasi terkait harga, promo, ketersediaan unit, komisi, dan ketentuan penjualan yang berlaku.`;
      return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
    },
    openWhatsapp(project) {
      const whatsappUrl = this.formatWhatsappUrl(project);
      if (whatsappUrl) {
        window.open(whatsappUrl, '_blank');
      }
    },
    async confirmRemove(project) {
      const result = await this.$swal({
        title: 'Hapus dari Shortlist Project Connect?',
        text: 'Project ini akan dihapus dari shortlist Anda.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel'),
        reverseButtons: true,
      });
      if (!result.value) return;

      try {
        await this.$store.dispatch('projectConnect/removeShortlist', project.project_id);
        await this.$swal(
          this.$t('general.success'),
          'Project berhasil dihapus dari shortlist.',
          'success',
        );
      } catch (error) {
        const message =
          error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors
            : 'Maaf terjadi kesalahan, silakan coba lagi nanti.';
        await this.$swal('Oops...', message, 'error');
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('projectConnect/restoreInitialState');
    await this.getShortlists();
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.shortlist-connect-page {
  min-height: 100vh;
  padding: 18px 0 64px;
  background: #fafafa;
}

.shortlist-connect-panel {
  position: relative;
  padding: 22px;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
  overflow: hidden;

  > * {
    position: relative;
    z-index: 1;
  }

  @media #{$phones} {
    padding: 12px;
    border-radius: 18px;
  }
}
</style>
